import {
  TrackingTrackingModelsAnalyticsDownloadDailySummary,
  useAPIQuery,
  TrackingApi,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
//import { ALL_ORDER_SESSION_STATUS, OrderProductionStatus, OrderSessionStatus } from "../../helper/licencesHelper";
//import { LicencesListFiltersType } from "./LicencesListFiltersType";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { ReportsDownloadListFiltersType } from "./reportsListFilterType";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useReports = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<
    TrackingTrackingModelsAnalyticsDownloadDailySummary,
    ReportsDownloadListFiltersType
  >({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    TrackingApi,
    ["reports", currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //const api = new ProductAnalyticsApi(baseApiConfig({ token }));
      console.log({ filters, currentPage, pageSize });
      let response;
      //   if (filters?.Products) {
      console.log(filters?.endTimeStamp);
      console.log(filters?.startTimeStamp);
      response = await api.analyticDailyDesignSummary({
        //offset: (currentPage - 1) * pageSize,
        //limit: pageSize,
        //sortBy: sortBy(),
        productCode:
          filters?.Products && !isEmpty(filters.Products)
            ? filters.Products
            : "",
        startTimestamp: filters?.startTimeStamp
          ? filters.startTimeStamp
          : undefined,
        endTimestamp: filters?.endTimeStamp ? filters.endTimeStamp : undefined,
      });
      // }

      //  setTotal(response?.total ? response?.total : 0);

      // Make logic to get data based on id
      var res = response?.list.reduce(function (agg: any, obj: any) {
        var objForId = agg.filter(function (idObj: any) {
          return idObj.id === obj.id && idObj.product_code === obj.product_code && idObj.type === obj.type;
        })[0];

        if (objForId) {
          objForId.total_downloads += obj.total_files;
          objForId.unique_downloads += obj.unique_files;
        } else {
          agg.push({
            id: obj.id,
            total_downloads: obj.total_files,
            user_name: obj.user_name,
            unique_downloads: obj.unique_files,
            first_name: obj.first_name,
            last_name: obj.last_name,
            product_code: obj.product_code,
            melco_customer_id: obj.melco_customer_id,
            type: obj.type
          });
        }

        return agg;
      }, []);
      console.log(res);
      //setTotal(res?.length ? res?.length : 0);
      return {
        tableData: res ? res : [],
        rawData: response?.list ? response.list : [],
      };
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};
